import { Activity, ContainerActivity, ActivityModel } from './activity';

export class ParallelActivity extends ContainerActivity<ActivityModel> {
  constructor(options: { [key: string]: any }) {
    super(options);
  }
}
